import React from 'react';
import { errorNotice } from './shared/PropTypes';

const ErrorNotice = ({ error = null, children = [], className = '' }) => (
  <div className={`error-message-container ${className}`}>
    {error && <div className="error-message">{error}</div>}
    {children}
  </div>
);

ErrorNotice.propTypes = errorNotice.props;

export default ErrorNotice;
